import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { registerTemplateKeys } from '../registerTemplateKeys'
import { RequestTypes } from '../requestTypes'
import { RegisterTemplate } from '@core/entities/register/RegisterTemplate'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useUpdateRegisterTemplateStatus = (
  options?: UseMutationOptions<
    RegisterTemplate,
    RequestErrorType,
    RequestTypes['updateRegisterTemplateStatus']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...registerTemplateKeys.updateRegisterTemplateStatus,
    retry: 0,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: registerTemplateKeys._def })
    },
    ...options,
  })
}
